import { gql } from '@apollo/client'

export const PROFILE_OVERVIEW = gql`
  query ProfileOverview(
    $startDate: ISO8601Date!
    $endDate: ISO8601Date!
    $previousStartDate: ISO8601Date!
    $previousEndDate: ISO8601Date!
    $includeMarketplaceListing: Boolean = false
    $upcomingStartDateTime: DateTimeRangeInput
  ) {
    lessonTypes @include(if: $includeMarketplaceListing) {
      id
      status
    }
    coachingInquiries {
      id
      createdAt
    }
    currentUser {
      coachProfileAnalytics(startDate: $startDate, endDate: $endDate) {
        impressions
        views
      }
      previousCoachProfileAnalytics: coachProfileAnalytics(
        startDate: $previousStartDate
        endDate: $previousEndDate
      ) {
        impressions
        views
      }
      groupEvents(
        startDateTime: $upcomingStartDateTime
        includeCanceled: false
      ) @include(if: $includeMarketplaceListing) {
        startDateTime
        tags
        registrationClosed
        registrationFull
        hasWaitlist
        sessions {
          startDateTime
        }
      }
      attributes {
        ... on Coach {
          hasPaidTierSubscription
          canPromoteContent
          bookingUrl
          freeTierLimitsReached
          preferences {
            acceptsLeads
          }
          facilities {
            id
            name
            coachProfilesFacilities {
              visible
            }
          }
          coachProfile {
            coachProfileId
            firstName
            lastName
            profilePhoto
            title
            status
            bookable
            city
            state
            customSlug
            facilities {
              facilityName
              city
              state
            }
            coach {
              canPromoteContent
            }
          }
        }
      }
    }
  }
`
